
import Stream from "../frp/stream";
import Server, { TYPE } from 'network/network_api'
import SETTINGS from 'settings'

export const REQUEST_TYPE =
{
    INIT : 1,
    SPIN : 2,
    FREESPIN : 3,
    ENTER_RISK : 4,
    TAKE_WIN : 5,
    CHOOSE_AT_RISK : 6,
    PROCEED_BONUS : 7,
    //START click when within bonus roulette:
    ROULETTE : 8,
    //aquire jackpot when it's winning displayed within roulette:
    JACKPOT : 9,
    //switch to only available next state whatever it is:
    PROCEED : 10,
    FINISH : 11,
    CUSTOM : 12,
    GO : 13,
};

/** Exists until other remnants of imperative approaches extinguishing.*/
export function reactiveToImperativeRequest( server, requestDesc )
{
    function result() {};
    function fail() {};
    function fatal() {};
    
    switch( requestDesc.type )
    {
        case REQUEST_TYPE.INIT:
            return server.handleLobby( result, fail, fatal, requestDesc.options );
        case REQUEST_TYPE.SPIN:
            return server.spin( requestDesc.lines, requestDesc.multiplier, result, fail, fatal, requestDesc.skipToRisk );
        case REQUEST_TYPE.FREESPIN:
            return server.freespin( result, fail, fatal );
        case REQUEST_TYPE.ENTER_RISK:
            return server.enterRisk( result, fail, fatal, requestDesc.riskType );
        case REQUEST_TYPE.TAKE_WIN:
            return server.takeWin( result, fail, fatal );
        case REQUEST_TYPE.CHOOSE_AT_RISK:
            return server.chooseAtRisk( requestDesc.userData, result, fail, fatal );
        case REQUEST_TYPE.PROCEED_BONUS:
            return server.proceedBonus( requestDesc.bonusType, requestDesc.choice, result, fail, fatal );
        case REQUEST_TYPE.ROULETTE:
            return server.goNextStage( TYPE.PRECURSOR, result, fail, fatal );
        case REQUEST_TYPE.JACKPOT:
            return server.goNextStage( TYPE.REGULAR, result, fail, fatal );
        case REQUEST_TYPE.PROCEED:
            return server.goNextStage( server.lastState.way_map[ 0 ], result, fail, fatal );
        case REQUEST_TYPE.FINISH:
            return server.finish( result, fail, fatal );
        case REQUEST_TYPE.CUSTOM:
            return requestDesc.f()
        case REQUEST_TYPE.GO:
            return server.goNextStage( requestDesc.stage, result, fail, fatal )
        default:
            throw 'undefined request desc type';
    }
}

/** Реактивная архитектура пока будет реализовываться и параллельно сосуществовать с функционирующей императивной.*/
export default function Server$( space )
{
    const $request = space.s( "request" );
    $request
        .name( space, 'imperative_request' )
        .with( space.s( 'server' ), ( desc, server ) => ({ desc, server }) )
        .filter( ({ server }) => !! server )
        .on( ({ desc, server }) => reactiveToImperativeRequest( server, desc ) );
    
    const $net = space.s( 'net' )
    
    //what game expects to get (expectation can become NOT resolved, so handlers must be able to branch to whatever received):
    const $pending = space.s( 'pending' )
    $request
        //when trying to reconnect, game should keep remaining within the state it failed to proceed:
        .filter( r => r.type != REQUEST_TYPE.INIT )
        .map( r => r.type )
        .to( $pending );
    $net.map( () => undefined ).to( $pending );
    
    //the same as $pending but without being replaced by undefined when request completes:
    const $lastRequest = space.s( 'lastRequest' )
    $request.map( r => r.type ).subscribe( $lastRequest );
}




// WEBPACK FOOTER //
// ./src/library/network/net.es6